import { debounce } from 'lodash';
import { SetStateAction } from 'react';

export const getFieldBasedOnLang = (field: any, lang: string = 'en') => {
  if (field == null) return null;

  return field[lang];
};

export const getStartAndEndDateOfMonth = (monthNumber: number) => {
  if (monthNumber < 1 || monthNumber > 12) {
    throw new Error('Invalid month number. Please provide a value between 1 and 12.');
  }

  const year = new Date().getFullYear();
  const startDate = new Date(year, monthNumber - 1, 1);
  const endDate = new Date(year, monthNumber, 0);

  return {
    startDate: startDate,
    endDate: endDate,
  };
};

export const getStartAndEndDateOfCurrentMonth = () => {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  return {
    startDate: firstDayOfMonth,
    endDate: lastDayOfMonth,
  };
};

export const getStartAndEndDateOfWeek = () => {
  const currentDate = new Date();
  const startDate = new Date(currentDate);
  startDate.setDate(startDate.getDate() - 7);

  return {
    startDate: startDate,
    endDate: currentDate,
  };
};

export const dataMapper = <T, R>(
  data: T[] | undefined,
  mapper: (item: T) => R
): R[] | undefined => {
  return data?.map((item) => mapper(item));
};

export const handleUploadFile = (acceptedFiles: File[], setFile: SetStateAction<any>) => {
  const file = acceptedFiles[0];

  const newFile = Object.assign(file, {
    preview: URL.createObjectURL(file),
  });

  setFile(newFile);
};

// For handling search in all tables inputs
export const handleDebouncedSearch = debounce((setState: SetStateAction<any>) => {
  setState();
}, 250);

// For get Reviewed By count in Chrome Extension Suggestions
export const handleGetReviewedCount = (
  array: {
    adminId: string | null;
    chromeExtId: string | null;
  }[]
) => {
  const adminsCount = array.filter((item) => item.adminId !== null);
  const chromeExtCount = array.filter((item) => item.chromeExtId !== null);

  return {
    reviewedAdminICount: `${adminsCount.length} Admin`,
    reviewedChromeExtCount: `${chromeExtCount.length} Parent`,
  };
};
